export const normalizarData = (dataStr) => {
    if (dataStr === null || dataStr === undefined || String(dataStr).trim() === '') return null;
    
    let str = String(dataStr).trim();

    // Tratamento para números Seriais do Excel (ex: 46002.99967592592)
    // A parte decimal (.999) representa o horário (23:59). Usamos Math.round
    // para que frações altas arredondem para o dia correto.
    if (!isNaN(str) && Number(str) > 20000) {
        const serialDay = Math.round(Number(str));
        // Excel base: serial 1 = 01/01/1900. Compensando bug do bissexto.
        const date = new Date(Date.UTC(1899, 11, 30 + serialDay));
        const y = date.getUTCFullYear();
        const m = String(date.getUTCMonth() + 1).padStart(2, '0');
        const d = String(date.getUTCDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
    
    // Tenta formato brasileiro DD/MM/YYYY
    const match = str.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if (match) return `${match[3]}-${match[2]}-${match[1]}`;
    
    // Fallback genérico para parse de Date
    const data = new Date(str);
    return !isNaN(data.getTime()) ? data.toISOString().split('T')[0] : null;
};
